var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgPencilTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_6807_126390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5835 8.7496L15.4168 7.91627C15.6357 7.6974 15.8093 7.43756 15.9278 7.15159C16.0462 6.86563 16.1072 6.55913 16.1072 6.2496C16.1072 5.94007 16.0462 5.63357 15.9278 5.34761C15.8093 5.06164 15.6357 4.8018 15.4168 4.58293C15.198 4.36406 14.9381 4.19045 14.6522 4.072C14.3662 3.95354 14.0597 3.89258 13.7502 3.89258C13.4406 3.89258 13.1341 3.95354 12.8482 4.072C12.5622 4.19045 12.3024 4.36406 12.0835 4.58293L3.3335 13.3329V16.6663H6.66683L8.3335 14.9996",
    stroke: "#002244",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.41602L14.5833 8.74935",
    stroke: "#002244",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6807_126390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 11.9993V13.9993L15.3332 14.666M17.3332 13.9993C17.3332 15.8403 15.8408 17.3327 13.9998 17.3327C12.1589 17.3327 10.6665 15.8403 10.6665 13.9993C10.6665 12.1584 12.1589 10.666 13.9998 10.666C15.8408 10.666 17.3332 12.1584 17.3332 13.9993Z",
    stroke: "#002244",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6807_126390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6807_126390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPencilTime);
export default __webpack_public_path__ + "static/media/svg_pencil_time.9a8a1e0ec245567ce7eec0714134dddc.svg";
export { ForwardRef as ReactComponent };